import React__default, { forwardRef } from 'react';
import * as Avatar$1 from '@radix-ui/react-avatar';
import { useRefObjectAsForwardedRef } from '../../hooks/useRefObjectAsForwardedRef.js';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 *
 * Contains all the parts of an avatar.
 *
 */
const Root = /*#__PURE__*/forwardRef(({
  children,
  asChild = false,
  sx,
  ...props
}, forwardedRef) => {
  const innerRef = React__default.useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  return /*#__PURE__*/React__default.createElement(Avatar$1.Root, _extends({
    ref: innerRef
  }, props), children);
});

/**
 *
 * The image to render. By default it will only render when it has loaded. You can use the onLoadingStatusChange handler if you need more control.
 *
 */
const Image = ({
  children,
  src,
  alt,
  asChild = false,
  ...props
}) => {
  // @TODO, check for empty string or alt text and throw error if none passed
  if (!alt) {
    console.error(`You must include accessible alt text with avatar images. If the avatar is purely decorative and is described by accompanying text, use an empty string ''. `);
  }
  return /*#__PURE__*/React__default.createElement(Avatar$1.Image, _extends({
    asChild: asChild,
    src: src,
    alt: alt
  }, props), children);
};
Image.displayName = "Image";
/**
 * An element that renders when the image hasn't loaded. This means that while it's loading, or if there was an error.
 *
 * If you notice a flash during loading, you can provide a delayMs prop to delay its rendering so it only renders for those with slower connections. For more control, use the onLoadingStatusChange handler on Avatar.Image.
 */
const Fallback = ({
  children,
  asChild = false,
  delayMs,
  ...props
}) => {
  return /*#__PURE__*/React__default.createElement(Avatar$1.Fallback, _extends({
    asChild: asChild,
    delayMs: delayMs
  }, props), children);
};
Fallback.displayName = "Fallback";
Root.displayName = 'Avatar';
Image.displayName = 'Image';
Fallback.displayName = 'Fallback';
var Avatar = Object.assign(Root, {
  Image,
  Fallback
});

export { Avatar as default };
